import { render, staticRenderFns } from "./bindCard.vue?vue&type=template&id=0ce0c908&scoped=true&"
import script from "./bindCard.vue?vue&type=script&lang=js&"
export * from "./bindCard.vue?vue&type=script&lang=js&"
import style0 from "./bindCard.vue?vue&type=style&index=0&id=0ce0c908&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce0c908",
  null
  
)

export default component.exports